import type { ReactNode } from "react";

interface WrappedCardFrameProps {
  title: string;
  body?: string;
  children?: ReactNode;
}

export const WrappedCardFrame = ({ title, body, children }: WrappedCardFrameProps) => (
  <article className="app-panel-raised flex min-h-[28rem] min-w-0 flex-col justify-center p-5 sm:p-6">
    <div>
      <div className="min-w-0 max-w-3xl">
        <h2 className="font-[var(--ds-font-display)] text-[length:var(--ds-type-heading-size)] font-medium leading-[var(--ds-type-heading-line)] tracking-[var(--ds-type-heading-tracking)] text-[var(--app-text)] sm:text-2xl">{title}</h2>
        {body ? <p className="mt-3 whitespace-pre-line text-sm leading-7 text-[var(--app-text-secondary)] sm:text-base">{body}</p> : null}
      </div>
      {children ? <div className="mt-6 min-w-0">{children}</div> : null}
    </div>
  </article>
);
